export default function BookMarkSolidSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.82 2H7.18001C5.05001 2 3.32001 3.74 3.32001 5.86V19.95C3.32001 21.75 4.61001 22.51 6.19001 21.64L11.07 18.93C11.59 18.64 12.43 18.64 12.94 18.93L17.82 21.64C19.4 22.52 20.69 21.76 20.69 19.95V5.86C20.68 3.74 18.95 2 16.82 2ZM14.5 11.4H12.75V13.21C12.75 13.62 12.41 13.96 12 13.96C11.59 13.96 11.25 13.62 11.25 13.21V11.4H9.50001C9.09001 11.4 8.75001 11.06 8.75001 10.65C8.75001 10.24 9.09001 9.9 9.50001 9.9H11.25V8.21C11.25 7.8 11.59 7.46 12 7.46C12.41 7.46 12.75 7.8 12.75 8.21V9.9H14.5C14.91 9.9 15.25 10.24 15.25 10.65C15.25 11.06 14.91 11.4 14.5 11.4Z" fill="#3B61EB" />
    </svg>
  )
}

